// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/batch/v1/job_service.proto (package ai.h2o.mlops.batch.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Job } from "./job_pb.js";

/**
 * Request message for CreateJob
 *
 * @generated from message ai.h2o.mlops.batch.v1.CreateJobRequest
 */
export const CreateJobRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.batch.v1.CreateJobRequest",
  () => [
    { no: 1, name: "parent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "job_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "job", kind: "message", T: Job },
  ],
);

/**
 * Response message for CreateJob
 *
 * @generated from message ai.h2o.mlops.batch.v1.CreateJobResponse
 */
export const CreateJobResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.batch.v1.CreateJobResponse",
  () => [
    { no: 1, name: "job", kind: "message", T: Job },
  ],
);

/**
 * Request message for GetJob
 *
 * @generated from message ai.h2o.mlops.batch.v1.GetJobRequest
 */
export const GetJobRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.batch.v1.GetJobRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Response message for GetJob
 *
 * @generated from message ai.h2o.mlops.batch.v1.GetJobResponse
 */
export const GetJobResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.batch.v1.GetJobResponse",
  () => [
    { no: 1, name: "job", kind: "message", T: Job },
  ],
);

/**
 * Request message for CancelJob. It will stop processing job and kill all resources, but job will be available to get.
 *
 * @generated from message ai.h2o.mlops.batch.v1.CancelJobRequest
 */
export const CancelJobRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.batch.v1.CancelJobRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Response message for CancelJob
 *
 * @generated from message ai.h2o.mlops.batch.v1.CancelJobResponse
 */
export const CancelJobResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.batch.v1.CancelJobResponse",
  () => [
    { no: 1, name: "job", kind: "message", T: Job },
  ],
);

/**
 * Request message for GetJobOutput
 *
 * @generated from message ai.h2o.mlops.batch.v1.GetJobOutputRequest
 */
export const GetJobOutputRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.batch.v1.GetJobOutputRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "since_time", kind: "message", T: Timestamp },
  ],
);

/**
 * Response message for GetJobOutput.
 *
 * @generated from message ai.h2o.mlops.batch.v1.JobOutputResponse
 */
export const JobOutputResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.batch.v1.JobOutputResponse",
  () => [
    { no: 1, name: "app_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "pod_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "container_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "timestamp", kind: "message", T: Timestamp },
    { no: 5, name: "line", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Request message for ListJobs
 *
 * @generated from message ai.h2o.mlops.batch.v1.ListJobsRequest
 */
export const ListJobsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.batch.v1.ListJobsRequest",
  () => [
    { no: 1, name: "parent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_size", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "order_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Response message for ListJobs
 *
 * @generated from message ai.h2o.mlops.batch.v1.ListJobsResponse
 */
export const ListJobsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.batch.v1.ListJobsResponse",
  () => [
    { no: 1, name: "jobs", kind: "message", T: Job, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Request message for DeleteJob
 * (-- api-linter: core::0135::force-field=disabled
 *     aip.dev/not-precedent: Executions will be always deleted, there is no point to move that on API level. --)
 *
 * @generated from message ai.h2o.mlops.batch.v1.DeleteJobRequest
 */
export const DeleteJobRequest = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.batch.v1.DeleteJobRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Response message for DeleteJob
 *
 * @generated from message ai.h2o.mlops.batch.v1.DeleteJobResponse
 */
export const DeleteJobResponse = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.mlops.batch.v1.DeleteJobResponse",
  [],
);

